import React from "react";
import Image from "../atoms/Image";
import Video from "../atoms/Video";

export default ({ layout, image, video, noSpacing }) =>
    <section className={ (!noSpacing ? "u-section-spacing" : "") + (!layout ? " u-container" : "") }>
        <div className={ "u-object-fit" + (layout ? " u-object-fit--16-9" : " u-object-fit--3-2") }>
            { (image && !video) &&
            <Image className="u-object-fit__media" image={ image }/>
            }
            { (video) &&
            <Video
                src={ video.file.url }
                className="u-object-fit__media"
                autoPlay
                playsInline
                loop
                muted
                poster={ image ? image.file.url : null }
            />
            }
        </div>
    </section>;
